import { Grid, Typography, Avatar } from '@mui/material';
import { ReactElement } from 'react';
import { userService, IApiUserAccount } from '@tap/data-providers';

type IUserFieldProps = {
    user: IApiUserAccount | undefined,
}

export const UserField = ({
    user,
}: IUserFieldProps): ReactElement => (
    <Grid
        container
        alignItems='center'
        sx={{
            position: 'relative',
            paddingLeft: '26px',
        }}
    >
        <Avatar
            sx={{
                width: 20,
                height: 20,
                top: 0,
                left: 0,
                marginRight: '6px',
                position: 'absolute',
            }}
        >
            {user ? user.lastName.charAt(0) : '?'}
        </Avatar>
        < Typography
            sx={{
                height: '21px',
            }}
        >
            {user ? userService.getUserFIO(user) : 'Не назначен'}
        </ Typography >
    </Grid>
); 
